import GlpTabs from './GlpTabs.vue'
import GlpTabPane from './GlpTabPane.vue'

export { GlpTabs, GlpTabPane }
